module.exports = __webpack_public_path__ + "img/corp-fsty-c_2x.a7d15210.jpg";